

import React, { Component } from 'react';
import {
    Box,
    Button,
    Grid,
    TextField,
    InputAdornment,
    CircularProgress,
    Menu,
    MenuItem,
    Typography,
    Tooltip,
    FormControl,
    InputLabel,
    Select,
    Autocomplete,
} from '@mui/material';
import { LocalizationProvider, DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTime } from 'luxon';
import { State, City, Country } from 'country-state-city';
import CommonValidation from '../CommonFunctions/CommonValidation';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { localGetItem } from '../../Utility/Services/CacheProviderService';
import ToastMsg from '../ToastMsg/ToastMsg';
import '../../Shell/NavbarApp.css';



const CalculateAgeFromDob = (dob) => {
    if (!dob) return "";
    const diff = DateTime.now().diff(DateTime.fromJSDate(dob), 'years');
    return Math.floor(diff.years);
};
const t = (text) => text;
const errorMessage = (message) => console.error(message);

// Main component
class CreateTeleRequest extends Component {
    constructor(props) {
        super(props);
        this.createRequestButtonRef = React.createRef();
        this.state = {
            "RequestPatientMenuPop": this.props.state.RequestPatientMenuPop,
            "SelectedRequestPatient": this.props.state.SelectedRequestPatient,
            "editPatientId": this.props.state.editPatientId,
            "RequestPatientName": this.props.state.RequestPatientName,
            "RequestPatientAge": this.props.state.RequestPatientAge,
            "RequestPatientDOB": this.props.state.RequestPatientDOB,
            "RequestPatientGender": this.props.state.RequestPatientGender,
            "SearchedRequestPatientList": this.props.state.SearchedRequestPatientList,
            "isappointRequest": this.props.state.isappointRequest,
            "address_1": this.props.state.address_1,
            "address_2": this.props.state.address_2,
            "city": this.props.state.city,
            "cityName": this.props.state.cityName,
            "state_code": this.props.state.state_code,
            "country_code": this.props.state.country_code,
            "pin_code": this.props.state.pin_code,
            "AllStates": this.props.state.AllStates,
            "AllCountry": this.props.state.AllCountry,
            "editAppointmentId": this.props.state.editAppointmentId,
            "RequestSelectedDocID": this.props.state.RequestSelectedDocID,
            "RequestSelectedSpecID": this.props.state.RequestSelectedSpecID,
            "DateOpen": this.props.state.DateOpen,
            "RequestAppointDatetym": this.props.state.RequestAppointDatetym,
            "RequestpurposeOfVisit": this.props.state.RequestpurposeOfVisit,
            "isClked": this.props.state.isClked,
            "filteredDocList": this.props.state.filteredDocList,
            "doctorList": this.props.state.doctorList,
            "spcInfo": this.props.state.spcInfo,
            "POVList": this.props.state.POVList,
            "docSelectedRequestPatient": this.props.state.docSelectedRequestPatient,
            "doceditPatientId": this.props.state.doceditPatientId,
            "docRequestAppointDatetym": this.props.state.docRequestAppointDatetym,
            "docRequestPatientName": this.props.state.docRequestPatientName,
            "docRequestSelectedDocID": this.props.state.docRequestSelectedDocID,
            "docRequestpurposeOfVisit": this.props.state.docRequestpurposeOfVisit,
            "docRequestSelectedSpecID": this.props.state.docRequestSelectedSpecID,
            "docRequestPatientGender": this.props.state.docRequestPatientGender,
            "doceditAppointmentId": this.props.state.doceditAppointmentId,
            "docRequestPatientAge": this.props.state.docRequestPatientAge,
            "isDocAppointRequest": this.props.state.isDocAppointRequest,
            "isDocAppointRequest": this.props.state.isDocAppointRequest,
            "docSearchedRequestPatientList": this.props.state.docSearchedRequestPatientList,
            "docRequestPatientMenuPop": this.props.state.docRequestPatientMenuPop,
            "docDateOpen": this.props.state.docDateOpen,
            "AppointmentId": this.props.state.AppointmentId,
            RequestPatientListAnchor: null,
            "docRequestMobileNumber": this.props.state?.docRequestMobileNumber,
            "RequestMobileNumber": this.props.state?.RequestMobileNumber,
            hasAbha: localGetItem("has_abha_service") === "true" ? true : false,   
            "is_qms_enabled": false,
            "isMandatory": false,
        };
    }

    componentDidMount() {
        const userInfo = JSON.parse(localGetItem("loggedInUserInfo"));
        this.setState({ 
            is_qms_enabled: !!userInfo?.is_qms_enabled,
            isMandatory: localGetItem('DocName_Spec_mandatory') === 'true' ? true : false
         })
    }


    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message 
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            isInfoMsg: false,
            isInfoMsgText: '',
        })
    }

    ClearRequestData() {
        this.setState({
            RequestPatientName: "",
            RequestMobileNumber: "",
            SelectedRequestPatient: {},
            RequestSelectedDocID: null,
            RequestSelectedSpecID: null,
            RequestPatientAge: "",
            RequestPatientName: "",
            RequestAppointDatetym: new Date(),
            RequestpurposeOfVisit: "",
            filteredDocList: [],
            editAppointmentId: null,
            editPatientId: null,
            isClked: false,
            patientSearch: '',
            address_1: "",
            address_2: "",
            city: "",
            cityName: City.getCitiesOfState("IN", "TN"),
            country_code: 'IN',
            state_code: 'TN',
            AllCountry: Country.getAllCountries(),
            AllStates: State.getStatesOfCountry("IN"),
            pin_code: "",
            RequestPatientMenuPop: false,
            RequestPatientListAnchor: null,
            SearchedRequestPatientList: [],
            RequestPatientDOB: null,
            RequestPatientGender: "",
        }, () => {
            let city_name = localGetItem('city_name')
            let state_name = localGetItem('state_name')
            let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
            let stateList = State.getStatesOfCountry(List?.countryCode)
            let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
            this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList })
        })
    }

    docClearRequestData() {
        this.setState({
            docRequestPatientName: "",
            docRequestMobileNumber: "",
            docSelectedRequestPatient: {},
            docRequestSelectedDocID: null,
            docRequestSelectedSpecID: null,
            docRequestPatientAge: "",
            docRequestPatientName: "",
            docRequestAppointDatetym: new Date(),
            docRequestpurposeOfVisit: "",
            docfilteredDocList: [],
            doceditAppointmentId: null,
            doceditPatientId: null,
            isClked: false,
            docDatePicker: new Date(),
            patientSearch: '',
            App_DocID: null,
            address_1: "",
            address_2: "",
            city: "",
            cityName: City.getCitiesOfState("IN", "TN"),
            country_code: 'IN',
            state_code: 'TN',
            AllCountry: Country.getAllCountries(),
            AllStates: State.getStatesOfCountry("IN"),
            pin_code: "",
            docRequestPatientMenuPop: false,
            docRequestPatientListAnchor: null,
            docSearchedRequestPatientList: [],
            docRequestPatientDOB: null,
            docRequestPatientGender: "",
        }, () => { this.props?.getDoctorAppointmentList() })
    }


    CreateAppointRequest(fromDoctor = false) {
        this.setState({ isClked: true })
        try {
            const { t } = this.props;
            var states = this.state;
            if ((states?.RequestMobileNumber.length === 10 && CommonValidation.numberOnly(states?.RequestMobileNumber) && CommonValidation.removeSpace(states?.RequestPatientName) != "") ||
                (states?.docRequestMobileNumber.length === 10 && CommonValidation.numberOnly(states?.docRequestMobileNumber) && CommonValidation.removeSpace(states?.docRequestPatientName) !== "")) {
                var AptDateTime = states.RequestAppointDatetym ? new Date(states.RequestAppointDatetym) : new Date(states.RequestAppointDatetym)
                var DocAptDateTime = states.docRequestAppointDatetym ? new Date(states.docRequestAppointDatetym) : new Date(states.docRequestAppointDatetym)
                var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd')
                var DocAptDate = DateTime?.fromJSDate(DocAptDateTime)?.toFormat('yyyy-MM-dd')
                var Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
                var DocAptime = DateTime?.fromJSDate(DocAptDateTime)?.toLocaleString(DateTime.TIME_24_WITH_SECONDS);
                let data = {}
                if (fromDoctor) {
                    let clinicId = localGetItem('SelectedDoctorClinicId')
                    data = {
                        "patient_name": CommonValidation.removeSpace(states?.docRequestPatientName),
                        "patient_id": states?.docSelectedRequestPatient?.patient_id ? states?.docSelectedRequestPatient?.patient_id : states?.doceditPatientId ? states?.doceditPatientId : null,
                        "doctor_id": states?.docRequestSelectedDocID?.doctor_id ? states?.docRequestSelectedDocID?.doctor_id : null,
                        "mobile": states?.docRequestMobileNumber,
                        "reason": states?.docRequestpurposeOfVisit ? states?.docRequestpurposeOfVisit : "",
                        "appointment_date": DocAptDate,
                        "appointment_time": DocAptime,
                        'clinic_id': clinicId,
                        "address_line_1": states.address_1 === null ? "" : CommonValidation.removeSpace(states.address_1),
                        "address_line_2": states.address_2 === null ? "" : CommonValidation.removeSpace(states.address_2),
                        "city_name": states.city === null ? "" : CommonValidation.removeSpace(states.city),
                        "state_name": states.state_code === null ? "" : CommonValidation.removeSpace(states.AllStates.find((item) => (item.isoCode === states.state_code))?.name),
                        "country": states.country_code === null ? "" : CommonValidation.removeSpace(states.AllCountry.find((item) => (item.isoCode === states.country_code))?.name),
                        "pincode": states.pin_code === null ? "" : CommonValidation.removeSpace(states.pin_code),
                        "speciality_id": states.docRequestSelectedSpecID?.id ? states.docRequestSelectedSpecID?.id : null,
                        "gender": states.docRequestPatientGender ? states.docRequestPatientGender : null,
                    }
                    if (this.state.doceditAppointmentId) {
                        data["id"] = states?.doceditAppointmentId
                        data["age"] = states?.docRequestPatientAge === "" ? null : states?.docRequestPatientAge
                    } else {
                        data["age"] = states?.docRequestPatientAge ? states?.docRequestPatientAge : null
                    }
                } else {
                    let AgeKey = typeof states?.RequestPatientAge === "string" ? states?.RequestPatientAge?.includes("Y") ? states?.RequestPatientAge : (states?.RequestPatientAge ? (states?.RequestPatientAge + "Y") : null) : (states?.RequestPatientAge ? (states?.RequestPatientAge + "Y") : null);
                    data = {
                        "patient_name": CommonValidation.removeSpace(states?.RequestPatientName),
                        "patient_id": states?.SelectedRequestPatient?.patient_id ? states?.SelectedRequestPatient?.patient_id : states?.editPatientId ? states?.editPatientId : null,
                        "doctor_id": states?.RequestSelectedDocID?.doctor_id ? states?.RequestSelectedDocID?.doctor_id : null,
                        "mobile": states?.RequestMobileNumber,
                        "reason": states?.RequestpurposeOfVisit ? states?.RequestpurposeOfVisit : "",
                        // "age": states?.SelectedRequestPatient?.patient_id ? null : states?.RequestPatientAge ? states?.RequestPatientAge?.replace('Y', '') : null,
                        "age": AgeKey === "" ? null : AgeKey,
                        "appointment_date": AptDate,
                        "appointment_time": Aptime,
                        "address_line_1": states.address_1 === null ? "" : CommonValidation.removeSpace(states.address_1),
                        "address_line_2": states.address_2 === null ? "" : CommonValidation.removeSpace(states.address_2),
                        "city_name": states.city === null ? "" : CommonValidation.removeSpace(states.city),
                        "state_name": states.state_code === null ? "" : CommonValidation.removeSpace(states.AllStates.find((item) => (item.isoCode === states.state_code))?.name),
                        "country": states.country_code === null ? "" : CommonValidation.removeSpace(states.AllCountry.find((item) => (item.isoCode === states.country_code))?.name),
                        "pincode": states.pin_code === null ? "" : CommonValidation.removeSpace(states.pin_code),
                        "speciality_id": states.RequestSelectedSpecID?.id ? states.RequestSelectedSpecID?.id : null,
                        "gender": states.RequestPatientGender ? states.RequestPatientGender : null,
                        "dob": states?.RequestPatientDOB ? (typeof states.RequestPatientDOB === 'string' ? DateTime.fromISO(states.RequestPatientDOB) : DateTime.fromJSDate(states.RequestPatientDOB) ).toFormat('yyyy-MM-dd') : null,
                    }
                    if (this.state.editAppointmentId) {
                        data["id"] = states?.editAppointmentId
                    }
                }
                RestAPIService.create(data, Serviceurls.FO_TELE_APPOINTMENT_REQUEST)
                    .then((response) => {
                        if (response.data.status === "success") {
                            this.successMessage(response.data.message)
                            this.setState({ SelectedRequestTab: "appointment_request" })
                            if (fromDoctor) {
                                this.props?.getDoctorAppointmentList(true)
                                this.docClearRequestData()
                            } else {
                                this.props.history.push({ pathname: "/OPHome", state: { NewAppointmentCreated: true, NewMessage: response?.data?.message } })
                                this.props?.getAppointRequests()
                                this.ClearRequestData()
                            }
                        }
                    }).catch((e) => {
                        if (e?.response?.data?.message) {
                            this.setState({ isClked: false })
                            this.props?.errorMessage(e.response.data.message)
                        } else {
                            this.setState({ isClked: false })
                            this.errorMessage(e.message)
                        }
                    })
            } else {
                this.setState({ isClked: false }, () => {
                    if (states?.RequestMobileNumber === "") {
                        this.errorMessage("Enter Mobile Number")
                    }
                    // else if ((!CommonValidation.removeSpace(states?.RequestPatientAge)) || (fromDoctor && !CommonValidation.removeSpace(states?.docRequestPatientAge))) {
                    //   this.errorMessage("Enter Patient Age")
                    // }
                    else if (CommonValidation.numberOnly(states?.RequestMobileNumber) && states?.RequestMobileNumber.length !== 10) {
                        this.errorMessage("Mobile Number Must be in 10 Digits")
                    }
                    else if (!CommonValidation.numberOnly(states?.RequestMobileNumber) && Object.keys(this.state.SelectedRequestPatient).length === 0) {
                        this.errorMessage("Invaild Mobile Number")
                    }
                    else if (CommonValidation.removeSpace(states?.RequestPatientName) === "") {
                        this.errorMessage("Enter Patient Name")
                    }
                    else if (states?.RequestSelectedDocID?.doctor_id === "" && this.state.isMandatory) {
                        this.errorMessage("Select Doctor")
                    } else if (states?.RequestSelectedSpecID?.id === "" && this.state.isMandatory) {
                        this.errorMessage("Select Speciality")
                    }
                })
            }
        }
        catch (e) {
            this.setState({ isClked: false })
            this.errorMessage(e.message)
        }
    }

    DoctorPatientSearch(DocRequest = false, MobNum = null) {
        try {
            let { t } = this.props;
            let SelectedDoctorClinic = localGetItem('SelectedDoctorClinicId')
            // ? localGetItem('SelectedDoctorClinicId') : (UserData?.service_type === "OPTOMETRY" ? "all" : "")
            let API_URL = ''
            if (DocRequest) {
                API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${MobNum}&address_key=&father_husband_key=&clinic_id=${SelectedDoctorClinic}&address=true`
                this.props?.AppointMobileSrch(true);
            } else if (this.state.isOptometry) {
                API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&clinic_id=${this.state.loggedInuserInfo?.clinic_id}&mother_name_key=${this.state.PatientMotherKey}`
            } else {
                var DobDate = new Date(this.state.FilterDob)
                var date = this.state.FilterDob ? DateTime.fromJSDate(DobDate).toFormat('yyyy-MM-dd') : ""
                API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&clinic_id=${this.state.SelectedDoctorClinic}&mother_name_key=${this.state.PatientMotherKey}&uhid=${this.state.FilterUHID}&dob=${date}&op_number=${this.state.FilterOP}`
                this.props?.isPatientisSearching(true)
            }
            RestAPIService.getAll(API_URL).
                then((response) => {
                    if (response.data.status === "success") {
                        this.props?.isPatientisSearching(false)
                        this.props?.AppointMobileSrch(false);
                        if (DocRequest) {
                            this.setState({
                                docSearchedRequestPatientList: response.data.data,
                                docRequestPatientMenuPop: response.data.data.length > 0 ? true : false

                            })
                        } else {
                            this.setState({
                                SearchDoctorPatientList: response.data.data,
                                // RequestPatientMenuPop: response?.data?.data?.patient?.length > 0 ? true : false
                            }, () => {
                                if (this.state.PatientNameSearchKey !== "" || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || this.state.FilterOP !== "") {
                                    if (response.data.data?.length > 0) {
                                        this.setState({ PatientSearchClicked: true, AddressFilterClicked: false })
                                    } else {
                                        this.errorMessage(t("NoRecordsFound"))
                                    }
                                }
                            })
                        }
                    }
                    else {
                        this.props?.isPatientisSearching(false)
                        this.props?.AppointMobileSrch(false);
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.props?.isPatientisSearching(false)
                    this.props?.AppointMobileSrch(false);
                })
        }
        catch (e) {
            this.props?.isPatientisSearching(false)
            this.props?.AppointMobileSrch(false);
            this.errorMessage(e.message)
        }
    }

    FOPatientSearch(ForRequest = false, MobNum = null) {
        try {
            let { t } = this.props;
            let API_URL = ""
            if (ForRequest) {
                API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${MobNum}&address_key=&father_husband_key=&address=true`
                this.props?.AppointMobileSrch(true);
            } else {
                var DobDate = new Date(this.state.FilterDob)
                var date = this.state.FilterDob ? DateTime.fromJSDate(DobDate).toFormat('yyyy-MM-dd') : ""
                API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&mother_name_key=${this.state.PatientMotherKey}&uhid=${this.state.FilterUHID}&dob=${date}&ip_number=${this.state.FilterIP}&op_number=${this.state.FilterOP}`
                this.props?.isPatientisSearching(true)
            }
            // this.props?.isPatientisSearching(true)
            RestAPIService.getAll(API_URL).
                then((response) => {
                    if (response.data.status === "success") {
                        this.props?.isPatientisSearching(false)
                        this.props?.AppointMobileSrch(false);
                        if (ForRequest) {
                            this.setState({
                                SearchedRequestPatientList: response.data.data,
                                RequestPatientMenuPop: response.data.data.length > 0 ? true : false
                            })
                        } else {
                            this.setState({
                                SearchedPatientList: response.data.data,
                                common_uhid: response?.data?.common_uhid ? response?.data?.common_uhid : false
                            }, () => {
                                if (this.state.PatientNameSearchKey !== "" || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || ((window.location.pathname === "/OPHome") ? this.state.FilterOP !== "" : this.state.FilterIP !== "")) {
                                    if (response.data.data.length > 0) {
                                        this.setState({ PatientSearchClicked: true, AddressFilterClicked: false })
                                    } else {
                                        this.setState({ PatientSearchClicked: false, AddressFilterClicked: false })
                                        this.errorMessage(t("NoRecordsFound"))
                                    }
                                }
                            })
                        }
                    }
                    else {
                        this.props?.isPatientisSearching(false)
                        this.props?.AppointMobileSrch(false);
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.props?.isPatientisSearching(false)
                    this.props?.AppointMobileSrch(false);
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    getPincodeToCity = (pincode) => {
        fetch("https://api.postalpincode.in/pincode/" + pincode)
            .then((res) => res.json())
            .then(response => {
                if (response && response[0].Status == "Success") {
                    var data = response[0].PostOffice
                    if (data && data.length > 0) {
                        var Api_state = (data[0]?.State) == 'Pondicherry' ? 'Puducherry' : (data[0]?.State)
                        this.setState({
                            city: this.state?.city ? this.state?.city : data[0].District,
                            AllStates: this.state?.state_code ? this.state?.AllStates : State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === data[0].Country))?.isoCode),
                            country_code: this.state?.country_code ? this.state?.country_code : this.state.AllCountry.find((item) => (item.name === data[0].Country))?.isoCode,
                        }, () => {
                            this.setState({
                                state_code: this.state?.state_code ? this.state?.state_code : this.state.AllStates.find((item) => (item.name === Api_state))?.isoCode,
                                cityName: this.state?.city ? this.state?.cityName : City.getCitiesOfState(this.state.country_code, this.state.AllStates.find((item) => (item.name === Api_state))?.isoCode)
                            })
                        })
                    }
                } else if (response.data.status == "fail") {
                }
            })
            .catch(e => {
            });
    }


    renderDropdown = (label, mt, Data = [], stateKey) => {
        var states = this.state
        return (
            <Box sx={{ width: '45%', mt: mt }}>
                <Autocomplete
                    size='small'
                    clearIcon={false}
                    sx={{ width: '14vw', marginTop: '1vw' }}
                    componentsProps={{ popper: { style: { width: label === 'Doctor' ? "23vw" : "14vw" } } }}
                    disabled={this.props?.is_Nurse && label === "Specialization" ? true : false}
                    options={Data}
                    getOptionLabel={(item) => ((label === "Doctor" ? item.doctor_name : label === "Specialization" ? item.name : label === "Patient Tag" ? item.patient_tag_name : label === "Appointment Type" ? item.appoinment_type : label === "Nurse" ? item.nurse : ""))}
                    value={states[stateKey]}
                    renderOption={label === 'Doctor' ? (props, item) => (
                        <Box>
                            {props["data-option-index"] === 0 ?
                                <Box className="eMed_App_Doctor_table_head">
                                    <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Doctor Name</Typography>
                                    <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Total App</Typography>
                                    <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>New App</Typography>
                                </Box> : null}
                            <Box component="li" className='eMed_App_Doctor_table_data' {...props}>
                                <div style={{ width: "50%" }}>
                                    {item?.doctor_name.length > 15 ? <Tooltip placement="top" title={item?.doctor_name} arrow><Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
                                        {this.state.is_qms_enabled && (
                                            <Tooltip placement="top" title={item.availability} arrow>
                                                <Box
                                                    sx={{
                                                        backgroundColor:
                                                             item.availability === "Available" ? "#1E972A" : "#B8170D",
                                                        width: "0.7vw",
                                                        height: "0.7vw",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                   
                                    <Typography>{item?.doctor_name.slice(0, 16) + "..."}</Typography></Box></Tooltip> : item?.doctor_name ? 

                                    <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>

                                                {this.state.is_qms_enabled && (
                                                    <Tooltip placement="top" title={item.availability} arrow>
                                                        <Box
                                                            sx={{
                                                                backgroundColor:
                                                                    item.availability === "Available" ? "#1E972A" : "#B8170D",
                                                                width: "0.7vw",
                                                                height: "0.7vw",
                                                                borderRadius: "50%",
                                                            }}
                                                        />
                                                    </Tooltip>
                )}
                                        <Typography>{item?.doctor_name}</Typography></Box> : "-"}
                                </div>
                                <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.total_appointment}</Typography>
                                <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.new_appointment}</Typography>
                                
                            </Box>
                        </Box>) : null}
                    onChange={(event, newValue) => {
                        states[stateKey] = newValue
                        if (newValue !== null && "doctor_id" in newValue) {
                            let docDetail = { ...newValue }
                            docDetail["name"] = docDetail["specialization_name"];
                            delete docDetail.specialization_name;
                            docDetail["id"] = docDetail["specialization_id"];
                            delete docDetail.specialization_id;
                            states["RequestSelectedSpecID"] = docDetail;
                        }
                        if (newValue !== null && "name" in newValue) {
                            let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter(item => item["specialization_id"] === newValue["id"])
                            states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
                            states["RequestSelectedDocID"] = null;
                        }
                        if (newValue === null && label === "Specialization") {
                            states["filteredDocList"] = states["doctorList"];
                        }
                        this.setState({ states })
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            placeholder={label}
                            required={this.state?.isMandatory}
                        />
                    )}
                />
            </Box>
        )
    }


    render() {
        const {
            SelectedRequestPatient,
            editPatientId,
            RequestMobileNumber,
            RequestPatientName,
            RequestPatientAge,
            RequestPatientDOB,
            RequestPatientGender,
            RequestPatientListAnchor,
            SearchedRequestPatientList,
            isappointRequest,
            address_1,
            address_2,
            city,
            cityName,
            state_code,
            country_code,
            pin_code,
            AllStates,
            AllCountry,
            filteredDocList,
            doctorList,
            spcInfo,
            DateOpen,
            RequestAppointDatetym,
            editAppointmentId,
            POVList,
            RequestpurposeOfVisit,
            isClked,
            RequestPatientMenuPop,
            docSelectedRequestPatient,
            isDocAppointRequest,
            docRequestPatientMenuPop,
            docSearchedRequestPatientList,
            docRequestPatientName,
            docRequestAppointDatetym,
            docRequestpurposeOfVisit,
            docRequestPatientAge,
            doceditPatientId,
            doceditAppointmentId,
        } = this.state;
        const AbhaDisable = ((SelectedRequestPatient?.patient_id || docSelectedRequestPatient?.patient_id) && (SelectedRequestPatient?.abha_health_id || docSelectedRequestPatient?.abha_health_id) && this.state.hasAbha) ? true : false
        const restrict_op_appointment_in_ip_patients = localGetItem('restrict_op_appointment_in_ip_patients') === "true";   
        return (
            this.props.FromDoctor === true ?
                <Box height={"40.2vh"} width={"52.5vw"}>
                    <Grid container className='eMed_IPappoint_Grid_row'>
                        <Grid item xs={4} paddingTop={"1vw"}>
                            <TextField
                                sx={{ width: '14vw', position: "relative" }}
                                size='small'
                                inputProps={{ maxLength: 15 }}
                                label={Object.keys(docSelectedRequestPatient).length > 0 ? "Mobile Number *" : "Mobile / UHID *"}
                                value={this.state.docRequestMobileNumber}
                                InputProps={{
                                    endAdornment: isDocAppointRequest ?
                                        <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
                                        : null,
                                }}
                                onChange={(e) => {

                                    let number = CommonValidation.ALPHA_NUMARIC(e.target.value);
                                    if (number || e.target.value === "") {
                                        this.setState({ docRequestMobileNumber: e.target.value, }, () => {
                                            if (Object.keys(this.state.docSelectedRequestPatient).length > 0) {
                                                this.setState({
                                                    docSelectedRequestPatient: {},
                                                    docRequestPatientName: "",
                                                    docRequestPatientAge: "",
                                                    docRequestPatientDOB: null,
                                                    docRequestPatientGender: "",
                                                    address_1: "",
                                                    address_2: "",
                                                })
                                            }
                                            if (number && this.state.docRequestMobileNumber?.length >= 10) {
                                                this.setState({}, () => { this.DoctorPatientSearch(true, this.state.docRequestMobileNumber) })
                                            }
                                        })
                                    }
                                }}
                                onKeyDown={(e) => {
                                    e.stopPropagation()
                                    if (this.state.RequestPatientListAnchor) {
                                        if (this.state.docRequestMobileNumber?.length > 5 && e.key === "Enter") {
                                            this.setState({}, () => {
                                                this.DoctorPatientSearch(true, this.state.docRequestMobileNumber)
                                            })
                                        }
                                        if (this.state.docRequestMobileNumber?.length <= 5 && e.key === "Enter") {
                                            this.errorMessage("Enter atleast 6 Characters for search")
                                        }
                                    } else {
                                        this.setState({
                                            RequestPatientListAnchor: e.currentTarget
                                        }, () => {
                                            if (this.state.docRequestMobileNumber?.length > 5 && e.key === "Enter") {
                                                this.setState({}, () => { this.DoctorPatientSearch(this.state.docRequestPatientMenuPop, this.state.docRequestMobileNumber) })
                                            }
                                            if (this.state.docRequestMobileNumber?.length <= 5 && e.key === "Enter") {
                                                this.errorMessage("Enter atleast 6 Characters for search")
                                            }
                                        })
                                    }
                                }}
                            />
                            <Menu
                                open={this.state.docRequestPatientMenuPop}
                                anchorEl={RequestPatientListAnchor}
                                // sx={{ position: 'absolute', top: '11vw', left: '-10vw', maxHeight: '20vw', overflow: 'auto' }}
                                className="eMed_Header_CreateRequest_Pop"
                                onClose={() => {
                                    this.setState({ docRequestPatientMenuPop: false, RequestPatientListAnchor: null, docSearchedRequestPatientList: [] })
                                }}
                            // anchorOrigin={{
                            //   vertical: 'top',
                            //   horizontal: 'center',
                            // }}
                            // transformOrigin={{
                            //   vertical: 'top',
                            //   horizontal: 'center',
                            // }}
                            >
                                <Typography className='eMed_Request_sugg_Head'>Patient Name | UHID</Typography>
                                {
                                    docSearchedRequestPatientList?.length > 0 ? docSearchedRequestPatientList?.map((item, index) => {
                                        let PatientFullName = `${(item?.first_name ? item?.first_name : "")} ${(item?.last_name ? item?.last_name : "")}`
                                        const disableAddIcon = (localGetItem('isNewBilling') === "true" && restrict_op_appointment_in_ip_patients && item?.ip_has_current_appointment) ? true : false;
                                        return (
                                            <MenuItem key={index} disabled = {disableAddIcon} onClick={() => {
                                                this.setState({
                                                    docSelectedRequestPatient: item,
                                                    docRequestPatientMenuPop: false,
                                                    docRequestMobileNumber: item?.mobile_number,
                                                    docRequestPatientName: item?.first_name ? item?.first_name + " " + item?.last_name : "-",
                                                    docRequestPatientAge: item?.patient_age ? item?.patient_age : CalculateAgeFromDob(item.dob !== null ? new Date(item?.dob) : new Date(item?.approx_dob)),
                                                    address_1: item?.address_line_1 ? item?.address_line_1 : "",
                                                    address_2: item?.address_line_2 ? item?.address_line_2 : "",
                                                    city: item?.city_name ? item?.city_name : "",
                                                    state_code: item?.state_name ? State.getStatesOfCountry(this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode)?.find((list) => (list.name === item?.state_name))?.isoCode : "",
                                                    country_code: item?.country ? this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode : "",
                                                    pin_code: item?.pincode ? item?.pincode : "",
                                                })
                                            }}
                                                sx={{ width: '14vw' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', width: '14vw' }}>
                                                    {(PatientFullName?.length > 15) ? <Tooltip title={PatientFullName} placement='top' arrow><div>
                                                        <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{(PatientFullName?.length > 12 ? PatientFullName?.slice(0, 10) + ("...") : PatientFullName)}</Typography></div>
                                                    </Tooltip> : <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{PatientFullName}</Typography>} | {item?.patient_account_number?.length > 10 ? <Tooltip title={item?.patient_account_number} placement='top' arrow><div>
                                                        <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{("..." + item?.patient_account_number?.slice(-8))}</Typography></div>
                                                    </Tooltip> : <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{item?.patient_account_number}</Typography>}
                                                </Box>
                                            </MenuItem>
                                        )
                                    }) : null
                                }
                            </Menu>
                        </Grid>
                        <Grid item xs={4} paddingTop={"1vw"} >
                            <TextField
                                sx={{ width: '14vw' }}
                                autoComplete='off'
                                disabled={Object.keys(docSelectedRequestPatient)?.length > 0}
                                label="Patient Name *"
                                value={docRequestPatientName}
                                onChange={(e) => {
                                    var isAlpha = CommonValidation.alphabetOnly(e.target.value)
                                    if (isAlpha || e.target.value == "") {
                                        this.setState({ docRequestPatientName: e.target.value })
                                    }
                                }}
                                size='small'
                                onKeyDown={(e) => { e.stopPropagation() }}
                            />
                        </Grid>
                        <Grid item xs={4} paddingTop={"1vw"}>
                            <TextField
                                sx={{ width: '14vw' }}
                                inputProps={{ maxLength: 3 }}
                                autoComplete='off'
                                disabled={Object.keys(docSelectedRequestPatient)?.length > 0}
                                label="Patient Age"
                                value={docRequestPatientAge}
                                onChange={(e) => {
                                    let number = CommonValidation.numberOnly(e.target.value);
                                    if ((e.target.value < 150) && (number || e.target.value === "")) {
                                        this.setState({ docRequestPatientAge: e.target.value })
                                    }
                                }}
                                size='small'
                                onKeyDown={(e) => { e.stopPropagation(); }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container className='eMed_IPappoint_Grid_row'  >
                        {/* ======> Commented for doctor and specilization not in doctor module */}
                        {/* <Grid item xs={4}>
                              {this.renderDropdown("Doctor", "0vw", this.state.filteredDocList.length > 0 ? this.state.filteredDocList : this.state.doctorList, "RequestSelectedDocID")}
                            </Grid>
                            <Grid item xs={4}>
                              {this.renderDropdown("Specialization", "0vw", this.state.spcInfo, "RequestSelectedSpecID")}
                            </Grid> */}
                        <Grid item xs={4} >
                            <Box sx={{ width: '93%', mt: '1vw' }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        open={this.state.docDateOpen}
                                        onOpen={() => { this.setState({ docDateOpen: true }) }}
                                        onClose={() => { this.setState({ docDateOpen: false }) }}
                                        inputFormat='dd-MM-yyyy & hh:mm a'
                                        value={docRequestAppointDatetym}
                                        disabled={doceditPatientId}
                                        minDate={new Date()}
                                        maxDate={new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0)}
                                        onChange={(newDate) => {
                                            if (newDate === null) {
                                                this.setState({ docRequestAppointDatetym: new Date() })
                                                // , () => this.getDoctorsList(true))
                                            }
                                            else {
                                                this.setState({ docRequestAppointDatetym: newDate })
                                                // , () => this.getDoctorsList(true))
                                            }
                                        }}
                                        renderInput={(params) => <TextField
                                            size='small'
                                            inputProps={{ style: { fontSize: '0.8vw' } }}
                                            disabled={doceditPatientId}
                                            onClick={() => { this.setState({ docDateOpen: true }) }}
                                            {...params}
                                            fullWidth
                                            sx={{ width: "14vw" }}
                                            variant='outlined'
                                            label="Appointment Date & Time *"
                                            onKeyDown={(e) => {
                                                e.stopPropagation();
                                                if (e.key === 'Tab') {
                                                    return;
                                                }
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Grid>
                        <Grid item xs={8}>
                            <Box>
                                <Autocomplete
                                    inputProps={{ maxLength: 250 }}
                                    options={POVList}
                                    getOptionLabel={(options) => options}
                                    onChange={(e, value) => {
                                        this.setState({
                                            docRequestpurposeOfVisit: value
                                        })
                                    }}
                                    onKeyDown={(e) => { e.stopPropagation() }}
                                    clearIcon={false}
                                    size='small'
                                    sx={{ mt: "1vw", width: '31vw' }}
                                    value={docRequestpurposeOfVisit}
                                    renderInput={(params) => <TextField onChange={(event) => {
                                        this.setState({
                                            docRequestpurposeOfVisit: event.target.value
                                        })
                                    }}
                                        {...params}
                                        placeholder="Purpose Of Visit"
                                    />}
                                />
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
                        <Grid item xs={4}>
                            {
                                <TextField
                                    sx={{ width: "14vw" }}
                                    size="small"
                                    autoComplete='off'
                                    inputProps={{ maxLength: 100 }}
                                    label={("Address 01")}
                                    value={this.state.address_1}
                                    disabled={Object.keys(docSelectedRequestPatient)?.length > 0}
                                    onChange={(e) => {
                                        this.setState({ address_1: e.target.value })
                                    }}
                                    onKeyDown={(e) => {
                                        e.stopPropagation()
                                    }}
                                />
                            }
                        </Grid>
                        <Grid item xs={4}>
                            {
                                <TextField
                                    sx={{ width: "14vw" }}
                                    size="small"
                                    inputProps={{ maxLength: 100 }}
                                    label={("Address 02")}
                                    disabled={Object.keys(docSelectedRequestPatient)?.length > 0}
                                    autoComplete='off'
                                    value={this.state.address_2}
                                    onChange={(e) => {
                                        this.setState({ address_2: e.target.value })
                                    }}
                                    onKeyDown={(e) => {
                                        e.stopPropagation()
                                    }}
                                />
                            }
                        </Grid>
                        <Grid item xs={4} >
                            <Autocomplete
                                sx={{ width: "14vw" }}
                                size="small"
                                options={cityName ? cityName : []}
                                getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
                                disabled={Object.keys(docSelectedRequestPatient)?.length > 0}
                                onChange={(e, value) => {
                                    this.setState({
                                        city: value?.name ? value?.name : '',
                                        // pin_code: '',
                                    })
                                }}
                                clearIcon={false}
                                value={city}
                                renderInput={(params) => (
                                    <TextField
                                        label={"City"}
                                        autoComplete='off'
                                        InputProps={{ ...params.InputProps }}
                                        onChange={(e) => this.setState({
                                            city: e.target.value,
                                            // pin_code: ''
                                        })}
                                        {...params}
                                    />)}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                            />


                        </Grid>
                    </Grid>


                    <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
                        <Grid item xs={4}>
                            <TextField
                                select
                                sx={{ width: '14vw' }}
                                size='small'
                                label={"Select State"}
                                value={state_code}
                                disabled={Object.keys(docSelectedRequestPatient)?.length > 0}
                                SelectProps={{
                                    MenuProps: { style: { maxHeight: 250, maxWidth: '12vw' } },
                                }}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const newStateCode = e.target.value;
                                    this.setState({ state_code: newStateCode },
                                        () => {
                                            this.setState({
                                                cityName: City.getCitiesOfState(country_code, newStateCode),
                                                city: ''
                                            })
                                        }
                                    );
                                }}
                            >
                                {AllStates.map((list) => (
                                    <MenuItem key={list.isoCode} value={list.isoCode}>
                                        {list.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                select
                                sx={{ width: '14vw' }}
                                size='small'
                                label={"Select Country"}
                                value={country_code}
                                disabled={Object.keys(docSelectedRequestPatient)?.length > 0}
                                SelectProps={{
                                    MenuProps: { style: { maxHeight: 250, maxWidth: '12vw' } },
                                }}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const newCountryCode = e.target.value;
                                    this.setState({ country_code: newCountryCode, state_code: "", city: '' }, () => {
                                        this.setState({ AllStates: State.getStatesOfCountry(newCountryCode), cityName: '' })
                                    });
                                }}
                            >
                                {AllCountry.map((list) => (
                                    <MenuItem key={list.isoCode} value={list.isoCode}>
                                        {list.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4} >
                            <TextField
                                sx={{ width: '14vw' }}
                                autoComplete='off'
                                inputProps={{ maxLength: 6 }}
                                label={"Pincode"}
                                variant="outlined"
                                value={pin_code}
                                disabled={Object.keys(docSelectedRequestPatient)?.length > 0}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    if ((CommonValidation.numberOnly(e.target.value) || e.target.value == "") && e.target.value.length <= 6) {
                                        this.setState({ pin_code: e.target.value, }, () => {
                                            if (pin_code && pin_code.length === 6) {
                                                this.getPincodeToCity(pin_code)
                                            }
                                        })
                                    }
                                }}

                                size="small"
                            />
                        </Grid>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography marginLeft={"2vw"}>{Object.keys(SelectedRequestPatient).length > 0 ? `UHID : ${SelectedRequestPatient?.patient_account_number}` : ""}</Typography>
                        <Box className="eMed_CreateRequest_BtnBox">
                            <Button size='small' id="eMed_Config_btn" sx={{ marginRight: '1vw' }} onClick={() => { this.docClearRequestData() }} variant='outlined'>Clear</Button>
                            <Button size='small' id="eMed_Config_btn" disabled={this.state.isClked} variant='contained' onClick={() => this.setState({ isClked: true }, () => this.CreateAppointRequest(true))}>
                                {doceditAppointmentId ? "Update Request" : "Create Request"}</Button>
                        </Box>
                    </Box>
                </Box>
                : <Box className="eMEd_CreateRequest_Box"  sx={{ width: '60vw' }}>
                    <Grid container className='eMed_IPappoint_Grid_row'>
                        <Grid item xs={4} paddingTop={"1vw"}>
                            <TextField
                                sx={{ width: '14vw', position: "relative" }}
                                size='small'
                                inputProps={{ maxLength: 15 }}
                                label={Object.keys(SelectedRequestPatient).length > 0 ? "Mobile Number *" : "Mobile / UHID *"}
                                value={RequestMobileNumber}
                                InputProps={{
                                    endAdornment: isappointRequest ?
                                        <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
                                        : null,
                                }}
                                onChange={(e) => {
                                    const number = CommonValidation.ALPHA_NUMARIC(e.target.value);
                                    if (number || e.target.value === "") {
                                        this.setState({ RequestMobileNumber: e.target.value }, () => {
                                            if (Object.keys(SelectedRequestPatient).length > 0 || editPatientId) {
                                                this.setState({
                                                    SelectedRequestPatient: {},
                                                    RequestPatientName: "",
                                                    RequestPatientAge: "",
                                                    editPatientId: null,
                                                    RequestPatientListAnchor: null,
                                                    RequestPatientDOB: null,
                                                    RequestPatientGender: "",
                                                    address_1: "",
                                                    address_2: "",
                                                });
                                            }
                                            if (number && this.state.RequestMobileNumber.length >= 10) {
                                                this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
                                            }
                                        });
                                    }
                                }}
                                onKeyDown={(e) => {
                                    e.stopPropagation()
                                    if (this.state.RequestPatientListAnchor) {
                                        if (this.state.RequestMobileNumber?.length > 5 && e.key === "Enter") {
                                            this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
                                        }
                                        if (this.state.RequestMobileNumber?.length <= 5 && e.key === "Enter") {
                                            this.errorMessage("Enter atleast 6 Characters for search")
                                        }
                                    } else {
                                        this.setState({
                                            RequestPatientListAnchor: e.currentTarget
                                        }, () => {
                                            if (this.state.RequestMobileNumber?.length > 5 && e.key === "Enter") {
                                                this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
                                            }
                                            if (this.state.RequestMobileNumber?.length <= 5 && e.key === "Enter") {
                                                this.errorMessage("Enter atleast 6 Characters for search")
                                            }
                                        })
                                    }
                                }}
                            />
                            <Menu
                                open={RequestPatientMenuPop}
                                anchorEl={RequestPatientListAnchor}
                                className="eMed_Header_CreateRequest_Pop"
                                onClose={() => {
                                    this.setState({ RequestPatientMenuPop: false, RequestPatientListAnchor: null, SearchedRequestPatientList: [] });
                                }}
                            >
                                <Typography className='eMed_Request_sugg_Head'>Patient Name | UHID</Typography>
                                {
                                    SearchedRequestPatientList.length > 0 ? SearchedRequestPatientList.map((item, index) => {
                                        let PatientFullName = `${(item?.first_name ? item?.first_name : "")} ${(item?.last_name ? item?.last_name : "")}`
                                        const disableAddIcon = (localGetItem('isNewBilling') === "true" && restrict_op_appointment_in_ip_patients && item?.ip_has_current_appointment) ? true : false;
                                        
                                        return (
                                            <MenuItem
                                                key={index}
                                                onClick={() => {
                                                    this.setState({
                                                        SelectedRequestPatient: item,
                                                        RequestPatientMenuPop: false,
                                                        RequestMobileNumber: item?.mobile_number,
                                                        RequestPatientName: item?.first_name ? item?.first_name + " " + item?.last_name : "-",
                                                        RequestPatientAge: item?.patient_age ? (typeof item?.patient_age === "string" ? item?.patient_age?.replace('Y', '') : item?.patient_age) : CalculateAgeFromDob(item.dob !== null ? new Date(item?.dob) : new Date(item?.approx_dob)),
                                                        address_1: item?.address_line_1 || "",
                                                        address_2: item?.address_line_2 || "",
                                                        city: item?.city_name || "",
                                                        state_code: item?.state_name ? State.getStatesOfCountry(AllCountry?.find((list) => (list.name === item?.country))?.isoCode)?.find((list) => (list.name === item?.state_name))?.isoCode : "",
                                                        country_code: item?.country ? AllCountry?.find((list) => (list.name === item?.country))?.isoCode : "",
                                                        pin_code: item?.pincode || "",
                                                        RequestPatientDOB: item?.dob ? item?.dob : item?.approx_dob ? item?.approx_dob: item?.patient_age ? this.props?.handleFindApproxDob(typeof item?.patient_age === "string" ? item?.patient_age?.replace('Y', '') : item?.patient_age) : null,
                                                        RequestPatientGender: item?.patient_gender ? (item?.patient_gender.toLowerCase().startsWith('m') ? "m" : item?.patient_gender.toLowerCase().startsWith('f') ? "f" : "t") : "",
                                                    });
                                                }}
                                                sx={{ width: '14vw' }}
                                                disabled = {disableAddIcon}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', width: '14vw' }}>
                                                    {(PatientFullName?.length > 15) ?
                                                        <Tooltip title={PatientFullName} placement='top' arrow>
                                                            <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>
                                                                {PatientFullName?.length > 12 ? PatientFullName?.slice(0, 10) + "..." : PatientFullName}
                                                            </Typography>
                                                        </Tooltip> :
                                                        <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>
                                                            {PatientFullName}
                                                        </Typography>} |
                                                    {item?.patient_account_number?.length > 10 ?
                                                        <Tooltip title={item?.patient_account_number} placement='top' arrow>
                                                            <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>
                                                                {"..." + item?.patient_account_number?.slice(-8)}
                                                            </Typography>
                                                        </Tooltip> :
                                                        <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>
                                                            {item?.patient_account_number}
                                                        </Typography>}
                                                </Box>
                                            </MenuItem>
                                        );
                                    }) : null
                                }
                            </Menu>
                        </Grid>
                        <Grid item xs={4} paddingTop={"1vw"}>
                            <TextField
                                sx={{ width: '14vw' }}
                                inputProps={{ maxLength: 32 }}
                                disabled={Object.keys(SelectedRequestPatient).length > 0 || editPatientId}
                                label="Patient Name *"
                                value={RequestPatientName}
                                onChange={(e) => {
                                    const isAlpha = CommonValidation.alphabetOnly(e.target.value);
                                    if ((isAlpha || e.target.value === "") && e.target.value?.length <= 100) {
                                        this.setState({ RequestPatientName: e.target.value });
                                    }
                                }}
                                size='small'
                                onKeyDown={(e) => { e.stopPropagation(); }}
                            />
                        </Grid>
                        <Grid item xs={4} paddingTop={"1vw"}>
                            <TextField
                                sx={{ width: '14vw' }}
                                inputProps={{ maxLength: 3 }}
                                disabled={Object.keys(SelectedRequestPatient).length > 0 || editPatientId}
                                label="Patient Age"
                                value={RequestPatientAge}
                                onChange={(e) => {
                                    const number = CommonValidation.numberOnly(e.target.value);
                                    if ((e.target.value < 150) && (number || e.target.value === "")) {
                                        this.setState({ RequestPatientAge: e.target.value }, () => {
                                            const approxDob = this.props?.handleFindApproxDob(e.target.value);
                                            this.setState({ RequestPatientDOB: approxDob });
                                        });
                                    }
                                }}
                                size='small'
                                onKeyDown={(e) => { e.stopPropagation(); }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
                        <Grid item xs={4}>
                            <TextField
                                select
                                sx={{ width: '14vw' }}
                                size='small'
                                label="Gender *"
                                value={RequestPatientGender}
                                onChange={(e) => this.setState({ RequestPatientGender: e.target.value })}
                                onKeyDown={(e) => e.stopPropagation()}
                                disabled={AbhaDisable || false}
                            >
                                <MenuItem key={1} value={"m"}>{t("Male")}</MenuItem>
                                <MenuItem key={2} value={"f"}>{t("Female")}</MenuItem>
                                <MenuItem key={3} value={"t"}>{t("TransGender")}</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    sx={{ width: '33vw' }}
                                    size='small'
                                    label="Date of Birth"
                                    inputFormat={"dd-MM-yyyy"}
                                    disabled={AbhaDisable || false}
                                    autoComplete="off"
                                    value={RequestPatientDOB}
                                    minDate={new Date("1872-01-01")}
                                    maxDate={DateTime.now()}
                                    onChange={(newDate) => {
                                        const age = this.props?.handleAgeCalculation(newDate);
                                        this.setState({
                                            RequestPatientDOB: newDate,
                                            RequestPatientAge: age,
                                        });
                                    }}
                                    renderInput={(params) => <TextField sx={{ width: '31vw' }} {...params} size='small' autoComplete="off" variant="outlined" fullWidth
                                        onKeyDown={(e) => {
                                            e.stopPropagation();
                                            if (e.key === 'Tab') {
                                                return;
                                            }
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                            }
                                        }}
                                    />}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
                        <Grid item xs={4}>
                            {this.renderDropdown("Doctor", "0vw", filteredDocList.length > 0 ? filteredDocList : doctorList, "RequestSelectedDocID")}
                        </Grid>
                        <Grid item xs={4}>
                            {this.renderDropdown("Specialization", "0vw", spcInfo, "RequestSelectedSpecID")}
                        </Grid>
                        <Grid item xs={4}>
                            <Box sx={{ width: '93%', mt: '1vw' }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        open={DateOpen}
                                        onOpen={() => this.setState({ DateOpen: true })}
                                        onClose={() => this.setState({ DateOpen: false })}
                                        inputFormat='dd-MM-yyyy & hh:mm a'
                                        value={RequestAppointDatetym}
                                        disabled={editPatientId}
                                        minDate={new Date()}
                                        maxDate={new Date(new Date().getFullYear(), new Date().getMonth() + 3, 0)}
                                        onChange={(newDate) => {
                                            if (newDate === null) {
                                                this.setState({ RequestAppointDatetym: DateTime.now() });
                                            } else {
                                                this.setState({ RequestAppointDatetym: newDate }, () => this.props?.getDoctorsList(true));
                                            }
                                        }}
                                        renderInput={(params) => <TextField
                                            sx={{ width: '14vw',
                                                '& .MuiIconButton-root': {
                                                    padding: '0px !important',
                                                },
                                             }}
                                            size='small'
                                            inputProps={{ style: { fontSize: '0.8vw' } }}
                                            disabled={editPatientId}
                                            onClick={() => this.setState({ DateOpen: true })}
                                            {...params}
                                            fullWidth
                                            variant='outlined'
                                            label="Appointment Date & Time *"
                                            onKeyDown={(e) => {
                                                e.stopPropagation();
                                                if (e.key === 'Tab') {
                                                    return;
                                                }
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: "14vw" }}
                                size="small"
                                inputProps={{ maxLength: 100, autoComplete: "new-password" }}
                                autoComplete="off"
                                disabled={Object.keys(SelectedRequestPatient).length > 0 || editPatientId}
                                label={t("Address 01")}
                                value={address_1}
                                onChange={(e) => this.setState({ address_1: e.target.value })}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                name="random-address-field"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: "14vw" }}
                                size="small"
                                inputProps={{ maxLength: 100, autoComplete: "new-password" }}
                                disabled={Object.keys(SelectedRequestPatient).length > 0 || editPatientId}
                                autoComplete='off'
                                label={t("Address 02")}
                                value={address_2}
                                onChange={(e) => this.setState({ address_2: e.target.value })}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                name="random-address-field"
                            />
                        </Grid>
                        <Grid item xs={4} >
                            <Autocomplete
                                sx={{ width: "14vw" }}
                                size="small"
                                options={cityName || []}
                                getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
                                disabled={Object.keys(SelectedRequestPatient).length > 0 || editPatientId}
                                onChange={(e, value) => this.setState({ city: value?.name || '' })}
                                clearIcon={false}
                                value={city}
                                renderInput={(params) => (
                                    <TextField
                                        label={"City"}
                                        autoComplete='off'
                                        InputProps={{ ...params.InputProps }}
                                        onChange={(e) => this.setState({ city: e.target.value })}
                                        {...params}
                                    />
                                )}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
                        <Grid item xs={4}>
                            <TextField
                                select
                                sx={{ width: '14vw' }}
                                size='small'
                                label={"Select State"}
                                value={state_code}
                                disabled={Object.keys(SelectedRequestPatient).length > 0 || editPatientId}
                                SelectProps={{
                                    MenuProps: { style: { maxHeight: 250, maxWidth: '12vw' } },
                                }}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    this.setState({ state_code: e.target.value },
                                        () => this.setState({ cityName: City.getCitiesOfState(country_code, e.target.value), city: '' }));
                                }}
                            >
                                {AllStates.map((list) => <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                select
                                sx={{ width: '14vw' }}
                                size='small'
                                label={"Select Country"}
                                value={country_code}
                                disabled={Object.keys(SelectedRequestPatient).length > 0 || editPatientId}
                                SelectProps={{
                                    MenuProps: { style: { maxHeight: 250, maxWidth: '12vw' } },
                                }}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const newCountryCode = e.target.value;
                                    this.setState(
                                        { country_code: newCountryCode, state_code: "", city: '' },
                                        () => this.setState({ AllStates: State.getStatesOfCountry(newCountryCode), cityName: '' })
                                    );
                                }}
                            >
                                {AllCountry.map((list) => (
                                    <MenuItem key={list.isoCode} value={list.isoCode}>
                                        {list.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: '14vw' }}
                                autoComplete='off'
                                inputProps={{ maxLength: 6, autoComplete: "new-password" }}
                                label={"Pincode"}
                                disabled={Object.keys(SelectedRequestPatient).length > 0 || editPatientId}
                                variant="outlined"
                                value={pin_code}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === 'Tab') {
                                        return;
                                    }
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    if ((CommonValidation.numberOnly(e.target.value) || e.target.value === "") && e.target.value?.length <= 6) {
                                        this.setState({ pin_code: e.target.value }, () => {
                                            if (pin_code && pin_code?.length === 6) {
                                                this.getPincodeToCity(pin_code);
                                            }
                                        });
                                    }
                                }}
                                size="small"
                                name="random-address-field"
                            />
                        </Grid>
                    </Grid>
                    <Autocomplete
                        inputProps={{ maxLength: 250 }}
                        options={POVList}
                        getOptionLabel={(options) => options}
                        onChange={(e, value) => this.setState({ RequestpurposeOfVisit: value })}
                        onKeyDown={(e) => { e.stopPropagation(); }}
                        clearIcon={false}
                        size='small'
                        sx={{ width: '44vw', paddingLeft: '2vw', mt: "2vw" }}
                        value={RequestpurposeOfVisit}
                        renderInput={(params) => <TextField
                            sx={{ width: "48vw" }}
                            onChange={(event) => this.setState({ RequestpurposeOfVisit: event.target.value })}
                            {...params}
                            placeholder="Purpose Of Visit"
                        />}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography marginLeft={"2vw"}>
                            {Object.keys(SelectedRequestPatient).length > 0 ? `UHID : ${SelectedRequestPatient?.patient_account_number}` : ""}
                        </Typography>
                        <Box className="eMed_CreateRequest_BtnBox">
                            <Button size='small' sx={{ marginRight: '1vw' }} onClick={() => { this.ClearRequestData() }} tabIndex={1} variant='outlined'>
                                Clear
                            </Button>
                            <Button size='small' ref={this.createRequestButtonRef} aria-disabled={isClked} variant='contained'
                                sx={{
                                    opacity: isClked ? 0.6 : 1,
                                    pointerEvents: isClked ? 'none' : 'auto',
                                    marginRight: '1vw'
                                }}
                                onClick={() => {
                                    // Only allow click if it's NOT disabled via isClked
                                    if (!isClked) {
                                        this.setState({ isClked: true }, () => this.CreateAppointRequest())
                                    }
                                }}
                                tabIndex={2}
                            >
                                {editAppointmentId ? "Update Request" : "Create Request"}
                            </Button>
                        </Box>
                    </Box>
                    {
                        this.state.isErrorMsg ?
                            <ToastMsg
                                severity={'error'}
                                msg={this.state.isErrorMsgText}
                                msgPop={this.msgClose.bind(this)}
                            />
                            : this.state.isSuccessMsg ?
                                <ToastMsg
                                    severity={'success'}
                                    msg={this.state.isSuccessMsgText}
                                    msgPop={this.msgClose.bind(this)}
                                /> : null
                    }
                </Box>
        );
    }
}

export default CreateTeleRequest;